export default "__VITE_ASSET__DAoe8iv5__"